import $ from "jquery";
import Constants from "./Constants";
import GigyaManager from "./GigyaManager";

class RestManager {

    testConnection(){
        return new Promise((resolve, reject) => {
            GigyaManager.getLoggedUser().then((user) => {
                let obj = {
                    token: Constants.API_TOKEN
                }
                $.ajax(Constants.API_ENDPOINT + '/api/test-connection', {
                    type: "POST",
                    dataType: "json",
                    data: JSON.stringify(obj)

                }).done((resp) => {
                    if(resp.status.runtime.data){
                        resolve(resp);
                    }else{
                        reject(resp);
                    }

                }).fail((resp) => {
                    reject(resp);
                });
            });
        });
    }

    userStatus(){
        return new Promise((resolve, reject) => {
            GigyaManager.getLoggedUserCached().then(async (user) => {
                let jwt = await GigyaManager.getJWT();
                let obj = {
                    token: Constants.API_TOKEN,
                    user_gigya_token: user.UID,
                    idtoken: jwt.id_token,
                    source: "1"
                }
                $.ajax(Constants.API_ENDPOINT + '/api/status/user', {
                    type: "POST",
                    dataType: "json",
                    data: JSON.stringify(obj)
                }).done((resp) => {
                    if(resp.status.runtime.data){
                        resolve(resp);
                    } else {
                        reject(resp);
                    }

                }).fail((resp) => {
                    reject(resp);
                });
            });
        });
    }

    playCode(code){
        return new Promise((resolve, reject) => {
            GigyaManager.getLoggedUserCached().then(async (user) => {
                let jwt = await GigyaManager.getJWT();
                let obj = {
                    token: Constants.API_TOKEN,
                    user_gigya_token: user.UID,
                    idtoken: jwt.id_token,
                    user_first_name: user.profile.firstName,
                    user_last_name: user.profile.lastName,
                    user_email: user.profile.email,
                    code:code,
                    source:"1"
                }
                $.ajax(Constants.API_ENDPOINT + '/api/play/code', {
                    type: "POST",
                    dataType: "json",
                    data: JSON.stringify(obj),
                }).done((resp) => {
                    if(resp.status.runtime.data){
                        resolve(resp);
                    } else {
                        reject(resp);
                    }

                }).fail((resp) => {
                    reject(resp);
                });
            });
        });
    }


    prizeRequest(form){
        return new Promise((resolve, reject) => {
            GigyaManager.getLoggedUserCached().then(async (user) => {
                let jwt = await GigyaManager.getJWT();
                let def = {
                    token: Constants.API_TOKEN,
                    user_gigya_token: user.UID,
                    idtoken: jwt.id_token,
                    source: "1"
                }
                $.extend(def, form);
                $.ajax(Constants.API_ENDPOINT + '/api/bag/request', {
                    type: "POST",
                    dataType: "json",
                    data: JSON.stringify(def),
                }).done((resp) => {
                    if(resp.status.runtime.data){
                        resolve(resp);
                    } else {
                        reject(resp);
                    }

                }).fail((resp) => {
                    reject(resp);
                });
            });
        });
    }

    iwPrizeRequest(form){
        return new Promise((resolve, reject) => {
            GigyaManager.getLoggedUserCached().then(async (user) => {
                let jwt = await GigyaManager.getJWT();
                let def = {
                    token: Constants.API_TOKEN,
                    user_gigya_token: user.UID,
                    idtoken: jwt.id_token,
                    source: "1"
                }
                $.extend(def, form);
                $.ajax(Constants.API_ENDPOINT + '/api/update/user', {
                    type: "POST",
                    dataType: "json",
                    data: JSON.stringify(def),
                }).done((resp) => {
                    if(resp.status.runtime.data){
                        resolve(resp);
                    } else {
                        reject(resp);
                    }

                }).fail((resp) => {
                    reject(resp);
                });
            });
        });
    }

    associateTelephone(telephone){
        return new Promise((resolve, reject) => {
            GigyaManager.getLoggedUserCached().then(async (user) => {
                let jwt = await GigyaManager.getJWT();
                let def = {
                    token: Constants.API_TOKEN,
                    user_gigya_token: user.UID,
                    idtoken: jwt.id_token,
                    user_phone_number: "39"+telephone,
                    user_first_name: user.profile.firstName,
                    user_last_name: user.profile.lastName,
                    user_email: user.profile.email,
                    source: "1"
                }
                $.ajax(Constants.API_ENDPOINT + '/api/merge/user', {
                    type: "POST",
                    dataType: "json",
                    data: JSON.stringify(def),
                }).done((resp) => {
                    if(resp.status.runtime.data){
                        resolve(resp);
                    } else {
                        reject(resp);
                    }

                }).fail((resp) => {
                    reject(resp);
                });
            });
        });
    }




}

export default new RestManager();
